// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotificationsPage_page__1SGg7 {
  display: grid;
  gap: 16px;
}

.NotificationsPage_toolbar__R0sCu {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
}

.NotificationsPage_scopeTabs__rDMSg {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.NotificationsPage_tab__KetK8,
.NotificationsPage_tabActive__HpCRl,
.NotificationsPage_primaryBtn__XfiUU,
.NotificationsPage_secondaryBtn__iYPI0 {
  border: none;
  border-radius: 12px;
  padding: 10px 14px;
  cursor: pointer;
  min-height: 44px;
}

.NotificationsPage_tab__KetK8 {
  background: var(--cl-surface-2, #f6f8fb);
}

.NotificationsPage_tabActive__HpCRl,
.NotificationsPage_primaryBtn__XfiUU {
  background: #1677ff;
  color: #fff;
}

.NotificationsPage_secondaryBtn__iYPI0 {
  background: var(--cl-surface-2, #f6f8fb);
}

.NotificationsPage_toolbarActions__YU-q2 {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}

.NotificationsPage_counter__MxZrx {
  font-weight: 700;
}

.NotificationsPage_groupList__d49Ks {
  display: grid;
  gap: 12px;
}

.NotificationsPage_groupCard__igM9C {
  display: grid;
  gap: 10px;
  border: 1px solid var(--cl-border, #d8dde6);
  border-radius: 16px;
  background: var(--cl-surface, #fff);
  padding: 16px;
  text-align: left;
  cursor: pointer;
}

.NotificationsPage_groupHeader__ljV7M,
.NotificationsPage_groupMeta__aaPoD {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.NotificationsPage_actors__cMy2n {
  color: var(--cl-dark, #475569);
}

.NotificationsPage_preview__cDp2A {
  color: var(--cl-dark, #334155);
}

.NotificationsPage_emptyState__Fk9o4 {
  border: 1px dashed var(--cl-border, #d8dde6);
  border-radius: 16px;
  padding: 28px;
  background: var(--cl-surface, #fff);
}

@media (max-width: 768px) {
  .NotificationsPage_toolbarActions__YU-q2 {
    width: 100%;
  }
  .NotificationsPage_primaryBtn__XfiUU,
  .NotificationsPage_secondaryBtn__iYPI0 {
    flex: 1 1 auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/NotificationsPage/NotificationsPage.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;;;;EAIE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,wCAAA;AACF;;AAEA;;EAEE,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,wCAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,2CAAA;EACA,mBAAA;EACA,mCAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;;EAEE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,4CAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AACF;;AAEA;EACE;IACE,WAAA;EACF;EAEA;;IAEE,cAAA;EAAF;AACF","sourcesContent":[".page {\n  display: grid;\n  gap: 16px;\n}\n\n.toolbar {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.scopeTabs {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.tab,\n.tabActive,\n.primaryBtn,\n.secondaryBtn {\n  border: none;\n  border-radius: 12px;\n  padding: 10px 14px;\n  cursor: pointer;\n  min-height: 44px;\n}\n\n.tab {\n  background: var(--cl-surface-2, #f6f8fb);\n}\n\n.tabActive,\n.primaryBtn {\n  background: #1677ff;\n  color: #fff;\n}\n\n.secondaryBtn {\n  background: var(--cl-surface-2, #f6f8fb);\n}\n\n.toolbarActions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.counter {\n  font-weight: 700;\n}\n\n.groupList {\n  display: grid;\n  gap: 12px;\n}\n\n.groupCard {\n  display: grid;\n  gap: 10px;\n  border: 1px solid var(--cl-border, #d8dde6);\n  border-radius: 16px;\n  background: var(--cl-surface, #fff);\n  padding: 16px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.groupHeader,\n.groupMeta {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.actors {\n  color: var(--cl-dark, #475569);\n}\n\n.preview {\n  color: var(--cl-dark, #334155);\n}\n\n.emptyState {\n  border: 1px dashed var(--cl-border, #d8dde6);\n  border-radius: 16px;\n  padding: 28px;\n  background: var(--cl-surface, #fff);\n}\n\n@media (max-width: 768px) {\n  .toolbarActions {\n    width: 100%;\n  }\n\n  .primaryBtn,\n  .secondaryBtn {\n    flex: 1 1 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `NotificationsPage_page__1SGg7`,
	"toolbar": `NotificationsPage_toolbar__R0sCu`,
	"scopeTabs": `NotificationsPage_scopeTabs__rDMSg`,
	"tab": `NotificationsPage_tab__KetK8`,
	"tabActive": `NotificationsPage_tabActive__HpCRl`,
	"primaryBtn": `NotificationsPage_primaryBtn__XfiUU`,
	"secondaryBtn": `NotificationsPage_secondaryBtn__iYPI0`,
	"toolbarActions": `NotificationsPage_toolbarActions__YU-q2`,
	"counter": `NotificationsPage_counter__MxZrx`,
	"groupList": `NotificationsPage_groupList__d49Ks`,
	"groupCard": `NotificationsPage_groupCard__igM9C`,
	"groupHeader": `NotificationsPage_groupHeader__ljV7M`,
	"groupMeta": `NotificationsPage_groupMeta__aaPoD`,
	"actors": `NotificationsPage_actors__cMy2n`,
	"preview": `NotificationsPage_preview__cDp2A`,
	"emptyState": `NotificationsPage_emptyState__Fk9o4`
};
export default ___CSS_LOADER_EXPORT___;
